import React, { Fragment } from 'react';

import NutritionOverview from './NutritionOverview';
import NutritionStats from './NutritionStats';

function NutritionStatsRow(props) {
  return (
    <Fragment>
      <NutritionStats {...props} />
      <NutritionOverview {...props} />
    </Fragment>
  );
}

export default NutritionStatsRow;
